import { toast } from "../components/message"
import { storeOrder } from "../mobile"
import { formataData } from "../utils"
import { estabelecimento } from "../Estabelecimento/estabelecimento"

function timeToMinutes(t) {
    const parts = t.split(':')
    return parseInt(parts[0], 10) * 60 + parseInt(parts[1] || '0', 10)
}

export function validaAgendamento() {
    const inputAgendamento = select('#agendamento-enable')
    if (inputAgendamento && inputAgendamento.checked) {
        const data = select('#agendamento-data')
        const time = select('#agendamento-hora')

        if (!data || !time || data.value == '' || time.value == '') {
            toast('Informe a data e hora para agendar o pedido')       
            return false    
        }

        // normalize time to HH:MM:SS format expected elsewhere
        const hora = time.value.length == 8 ? time.value : (time.value.length === 5 ? time.value + ':00' : time.value + ':00')

        const parsedDate = new Date(data.value.indexOf('/') > -1 ? data.value.split('/').reverse().join('/') : data.value)
        if (isNaN(parsedDate.getTime())) {
            toast('Data inválida')
            return false
        }

        const dateTime = new Date(parsedDate.getFullYear(), parsedDate.getMonth(), parsedDate.getDate(), ...hora.split(':').map((v)=>parseInt(v,10)))

        if (dateTime < new Date()) {
            toast('Data e hora devem ser maiores que a data atual')
            return false
        }

        // valida se o dia está aberto e se a hora está dentro dos intervalos
        const dayIndex = dateTime.getDay()
        const dias = (estabelecimento && estabelecimento.diasDelivery) || []
        const selectedDay = dias.find(d => Number(d.DiaDaSemana) == Number(dayIndex))
        if (!selectedDay || selectedDay.Aberto === false) {
            toast('Data selecionada está fechada para entrega')
            return false
        }

        const intervals = selectedDay.Intervalos || []
        if (!intervals || intervals.length === 0) {
            toast('Nenhum horário disponível neste dia')
            return false
        }

        const minuteValue = timeToMinutes(hora.slice(0,5))
        // check if inside any interval
        const inside = intervals.some(itv => {
            const start = timeToMinutes(itv.StartTime || '00:00')
            const end = timeToMinutes(itv.EndTime || '00:00')
            return minuteValue >= start && minuteValue <= end
        })

        if (!inside) {
            // try to give information about bounds
            const first = intervals[0]
            const last = intervals[intervals.length-1]
            const min = first ? first.StartTime : null
            const max = last ? last.EndTime : null
            toast(`Hora inválida. Horários permitidos entre ${min} e ${max}`)
            return false
        }

        // success: store values
        storeOrder.DataEntrega = formataData({ data: dateTime }).dataString
        storeOrder.HoraEntrega = hora
        storeOrder.DataEntregaTicks = (dateTime.getTime() * 10000 + 621355968000000000).toString()
    }

    return true
}
